import { getNativeFontScale } from '@polygraf/shared'

/**
 * Follow the phone's system text size inside the mobile app's WebView.
 *
 * WKWebView ignores iOS Dynamic Type and the transcript screen pins Android's
 * `textZoom` to 100, so with the largest system text the app's own screens
 * grew while the viewer's header and settings stayed at their web sizes
 * (MU, 7. 10. 2026). The native shell injects `PixelRatio.getFontScale()` as
 * `fontScale`; this hands it to every Tailwind text size through
 * `--text-scale` (tailwind.config.ts). A no-op on the web, where there is no
 * bridge and the browser applies the user's own text size.
 */
export function applyNativeTextScale(root: HTMLElement = document.documentElement): void {
	const scale = getNativeFontScale()
	if (scale === null || !Number.isFinite(scale) || scale <= 0) return
	root.style.setProperty('--text-scale', String(scale))
}
